import { Routes, Route, Link, useLocation } from "react-router-dom";
import { Layout, Sidebar, Header, NavItem } from "./components/Layout";
import { Dashboard } from "./pages/Dashboard";
import { Opportunities } from "./pages/Opportunities";
import { Pitches } from "./pages/Pitches";
import { Companies } from "./pages/Companies";
import { Settings } from "./pages/Settings";
import { useAuth } from "./hooks/useAuth";

const navigation = [
  { name: "Dashboard", href: "/", icon: "LayoutDashboard" },
  { name: "Opportunities", href: "/opportunities", icon: "Briefcase" },
  { name: "Pitches", href: "/pitches", icon: "FileText" },
  { name: "Companies", href: "/companies", icon: "Building2" },
  { name: "Settings", href: "/settings", icon: "Settings" }
];

export function App() {
  const { isAuthenticated, login } = useAuth();
  const location = useLocation();
  
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="card p-8 w-full max-w-md">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-100 text-primary-600 mb-4">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-slate-900">Opportunity Scanner</h1>
            <p className="text-slate-500 mt-1">Sign in to review opportunities</p>
          </div>
          <button
            onClick={login}
            className="btn-primary w-full"
          >
            Sign in with GitHub
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <Layout>
      <Sidebar navigation={navigation} />
      <Header />
      <main className="flex-1 p-6 lg:p-8 overflow-auto">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/pitches" element={<Pitches />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </Layout>
  );
}